<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiCloseCircleOutline } from "@mdi/js";
export default {
  name: "MdiCloseCircleOutline",
  data() {
    return {
      svgPath: mdiCloseCircleOutline,
    };
  },
};
</script>
